/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

import { CreateNewAccountApiParameter, createNewCustomerAccount } from "@monsma/App/Services/CreateNewAccountService";

type createNewAccountParameter = {
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    companyName: string;
    typeOfBusiness: string;
    businessAddress: string;
    apartmentNo: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    comments: string;
} & HasOnSuccess &
    HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<createNewAccountParameter, CreateNewAccountApiParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        firstName: props.parameter.firstName,
        lastName: props.parameter.lastName,
        emailAddress: props.parameter.emailAddress,
        phoneNumber: props.parameter.phoneNumber,
        companyName: props.parameter.companyName,
        typeOfBusiness: props.parameter.typeOfBusiness,
        businessAddress: props.parameter.businessAddress,
        apartmentNo: props.parameter.apartmentNo,
        city: props.parameter.city,
        state: props.parameter.state,
        postalCode: props.parameter.postalCode,
        country: props.parameter.country,
        comments: props.parameter.comments,
    };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await createNewCustomerAccount(props.apiParameter);
    } catch (error) {
        props.parameter.onError?.(error.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const createNewAccount = createHandlerChainRunner(chain, "CreateNewAccount");
export default createNewAccount;
